import { ElementRef, Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MessageService } from '../message';

/** Service com funções uteis para trabalhar com formulários */
@Injectable({
    providedIn: 'root'
})
export class FormsUtilsService {

    constructor(private messageService: MessageService) { }

    /**
     * Torna todos os campos do formulário "sujos" para exibir as mensagens de campos inválidos
     */
    makeAllFieldsDirty(form: NgForm) {
        if (!form) {
            return;
        }

        for (const key in form.controls) {
            if (form.controls.hasOwnProperty(key)) {
                const control = form.controls[key];
                control.markAsDirty();
            }
        }
    }

    /** Desabilita todos os campos do formulário */
    disableAllFields(form: ElementRef = null) {
        if (form) {
            jQuery(form.nativeElement).find('.form-control').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery(form.nativeElement).find('.container-datepicker button').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery(form.nativeElement).find('.typeahead button').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery(form.nativeElement).find('input[type=radio]').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery(form.nativeElement).find('input[type=checkbox]').attr('disabled', 'disabled').attr('readonly', 'readonly');
        } else {
            jQuery('form').find('.form-control').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery('form').find('.container-datepicker button').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery('form').find('.typeahead button').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery('form').find('input[type=radio]').attr('disabled', 'disabled').attr('readonly', 'readonly');
            jQuery('form').find('input[type=checkbox]').attr('disabled', 'disabled').attr('readonly', 'readonly');
        }
    }

    /** Habilita todos os campos do formulário */
    enableAllFields(form: ElementRef = null) {
        if (form) {
            jQuery(form.nativeElement).find('.form-control').removeAttr('disabled').removeAttr('readonly');
            jQuery(form.nativeElement).find('.container-datepicker button').removeAttr('disabled').removeAttr('readonly');
            jQuery(form.nativeElement).find('.typeahead button').removeAttr('disabled').removeAttr('readonly');
            jQuery(form.nativeElement).find('input[type=radio]').removeAttr('disabled').removeAttr('readonly');
            jQuery(form.nativeElement).find('input[type=checkbox]').removeAttr('disabled').removeAttr('readonly');
        } else {
            jQuery('form').find('.form-control').removeAttr('disabled').removeAttr('readonly');
            jQuery('form').find('.container-datepicker button').removeAttr('disabled').removeAttr('readonly');
            jQuery('form').find('.typeahead button').removeAttr('disabled').removeAttr('readonly');
            jQuery('form').find('input[type=radio]').removeAttr('disabled').removeAttr('readonly');
            jQuery('form').find('input[type=checkbox]').removeAttr('disabled').removeAttr('readonly');
        }
    }

    /** Habilita o campo informado */
    enableField(id: string) {
        jQuery('form').find(id).removeAttr('disabled').removeAttr('readonly');
    }

    /**
     * Exibe mensagem que o formulário está invalido ao usuário
     */
    showMsgFormInvalid() {
        this.messageService.info('Para salvar é preciso informar corretamente todos os campos destacados em vermelho', 'Informação');
    }

    /**
     * Exibe mensagem que o registro foi salvo com sucesso
     */
    showMsgRegistroSalvo() {
        this.messageService.success('', 'Registro salvo com sucesso');
    }
}
